module.exports = "\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/typepage/typepage.component.html
// module id = ../../../../../src/app/admin/page/typepage/typepage.component.html
// module chunks = main